import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * 电能统计-获取路灯
	 * @param {number} 路灯编号
	**/
	getStatisticsLamp( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/getStatisticsLamp',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 电能统计-获取结果
	 * @param {lamp_id} 路灯ID
	 * @param {date} 路灯编号
	**/
	getElectricityConsumptionStatistics( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/getElectricityConsumptionStatistics',
	    method: 'GET',
	    params
	  })
	}
}